module.exports = __webpack_public_path__ + "img/Linux.2db8e84.png";